import { createContext } from 'react';
import { INewbuildingLayout } from '../../types/layouts/layout';

export const CardContext = createContext<INewbuildingLayout>({} as INewbuildingLayout);
